import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-final-quota',
  templateUrl: './edit-final-quota.component.html',
  styleUrls: ['./edit-final-quota.component.css']
})
export class EditFinalQuotaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
